// extracted by mini-css-extract-plugin
export var addNoScroll = "ImageGallery-module--add-no-scroll--25a3d";
export var cdsAssistiveText = "ImageGallery-module--cds--assistive-text--b8923";
export var cdsVisuallyHidden = "ImageGallery-module--cds--visually-hidden--3a284";
export var closeButton = "ImageGallery-module--close-button--d76eb";
export var column = "ImageGallery-module--column--eafc2";
export var figure = "ImageGallery-module--figure--18937";
export var firstRightNav = "ImageGallery-module--first-right-nav--9424e";
export var galleryContainer = "ImageGallery-module--gallery-container--c9167";
export var galleryGrid = "ImageGallery-module--gallery-grid--e353e";
export var galleryRow = "ImageGallery-module--gallery-row--08374";
export var hideFeedback = "ImageGallery-module--hide-feedback--db81c";
export var icon = "ImageGallery-module--icon--3d502";
export var imageButtonWrapper = "ImageGallery-module--image-button-wrapper--d27fb";
export var imageInDialog = "ImageGallery-module--image-in-dialog--f6708";
export var imageTitle = "ImageGallery-module--image-title--e7f36";
export var inDialogGalleryContainer = "ImageGallery-module--in-dialog-gallery-container--77af7";
export var leftNav = "ImageGallery-module--left-nav--d1741";
export var navButtons = "ImageGallery-module--nav-buttons--e85ed";
export var navButtonsContainer = "ImageGallery-module--nav-buttons-container--60e7f";
export var rightNav = "ImageGallery-module--right-nav--a921c";
export var showFeedback = "ImageGallery-module--show-feedback--85f8f";
export var skeleton = "ImageGallery-module--skeleton--046e3";